export const standardWatchFilePaths = [
  "**/*.ts",
  "**/*.tsx",
  "**/*.js",
  "**/*.jsx",
  "**/*.json",
  "pnpm-lock.yaml",
];

export const standardWatchIgnoreRegex = /(node_modules)/;
